var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnglish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "76hhzlhb9a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .5h24v18H0V.5z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#76hhzlhb9a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 .5v18h24V.5H0z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "yq2uvzhdxb",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 19
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 .5v18h24V.5H0z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#yq2uvzhdxb)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4qeb94axzc",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 19
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .5h24v18H0V.5z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#4qeb94axzc)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m-2.673 17.215 5.281 2.233L24.12 2.928 26.905-.39l-5.647-.747-8.774 7.119-7.062 4.796-8.095 6.437z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m-1.95 18.779 2.691 1.296L25.905-.699h-3.777L-1.95 18.779z",
    fill: "#F50100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m26.672 17.215-5.282 2.233L-.12 2.928-2.906-.39l5.647-.747 8.774 7.119 7.062 4.796 8.095 6.437z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m26.492 18.338-2.69 1.296-10.716-8.895-3.177-.994L-3.174-.379H.604L13.68 9.505l3.473 1.192 9.339 7.64z",
    fill: "#F50100"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.833-1H9.167v7.5H-1.48v6H9.167V20h5.666v-7.5H25.52v-6H14.833V-1z",
    fill: "#F50100"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "3xl2pwapvd",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -1,
    width: 28,
    height: 21
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.833-1H9.167v7.5H-1.48v6H9.167V20h5.666v-7.5H25.52v-6H14.833V-1z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#3xl2pwapvd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.167-1v-1.5h-1.5V-1h1.5zm5.666 0h1.5v-1.5h-1.5V-1zM9.167 6.5V8h1.5V6.5h-1.5zm-10.646 0V5h-1.5v1.5h1.5zm0 6h-1.5V14h1.5v-1.5zm10.646 0h1.5V11h-1.5v1.5zm0 7.5h-1.5v1.5h1.5V20zm5.666 0v1.5h1.5V20h-1.5zm0-7.5V11h-1.5v1.5h1.5zm10.687 0V14h1.5v-1.5h-1.5zm0-6h1.5V5h-1.5v1.5zm-10.687 0h-1.5V8h1.5V6.5zM9.167.5h5.666v-3H9.167v3zm1.5 6V-1h-3v7.5h3zM-1.48 8H9.167V5H-1.48v3zm1.5 4.5v-6h-3v6h3zM9.167 11H-1.48v3H9.167v-3zm1.5 9v-7.5h-3V20h3zm4.166-1.5H9.167v3h5.666v-3zm-1.5-6V20h3v-7.5h-3zM25.52 11H14.833v3H25.52v-3zm-1.5-4.5v6h3v-6h-3zM14.833 8H25.52V5H14.833v3zm-1.5-9v7.5h3V-1h-3z",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.eb7ee4c0583e9b65344cf12980ba7839.svg";
export { ForwardRef as ReactComponent };